export const getOrGenerateDeviceUUID = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return "";
  }
  
  let uuid = localStorage.getItem("vmass_device_uuid");
  if (!uuid) {
    uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
    localStorage.setItem("vmass_device_uuid", uuid);
  }
  return uuid;
};
